import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNaN',
  standalone: true,
})
export class IsNaNPipe implements PipeTransform {
  public transform(value: number): boolean {
    return Number.isNaN(value);
  }
}
